import { render } from "./TournamentCompetitionPanel.vue?vue&type=template&id=35fa61cd&scoped=true"
import script from "./TournamentCompetitionPanel.vue?vue&type=script&lang=js"
export * from "./TournamentCompetitionPanel.vue?vue&type=script&lang=js"

import "./tournamentCompetition.css?vue&type=style&index=0&id=35fa61cd&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35fa61cd"]])

export default __exports__